<template>
	<Page animate>
		<template v-slot:content>
			<div class="top">
				<svg class="icon" width="80" height="80" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M48 96C74.5097 96 96 74.5097 96 48C96 21.4903 74.5097 0 48 0C21.4903 0 0 21.4903 0 48C0 74.5097 21.4903 96 48 96ZM38.509 45.5346H42.4799V35.6073C42.4799 32.3177 45.1466 29.651 48.4362 29.651C51.7258 29.651 54.3926 32.3177 54.3926 35.6073V39.5782H58.3635V35.6073C58.3635 30.1246 53.9189 25.6801 48.4362 25.6801C42.9536 25.6801 38.509 30.1246 38.509 35.6073V45.5346ZM36.5236 45.5347H60.349C62.5421 45.5347 64.3199 47.3125 64.3199 49.5056V65.3892C64.3199 67.5823 62.5421 69.3601 60.349 69.3601H36.5236C34.3305 69.3601 32.5527 67.5823 32.5527 65.3892V49.5056C32.5527 47.3125 34.3305 45.5347 36.5236 45.5347ZM36.5237 49.5056V65.3892H60.3491V49.5056H36.5237ZM48.4363 59.4328C49.5328 59.4328 50.4217 58.5439 50.4217 57.4474C50.4217 56.3508 49.5328 55.4619 48.4363 55.4619C47.3397 55.4619 46.4508 56.3508 46.4508 57.4474C46.4508 58.5439 47.3397 59.4328 48.4363 59.4328Z"
						fill="white"
					/>
				</svg>

				<div class="title">Congratulations!</div>
				<div class="subtitle">You have unlocked Premium Access</div>
			</div>

			<div class="bottom">
				<div class="container">
					<div class="note">
						<div class="note--icon">
							<svg width="22" height="35" viewBox="0 0 22 35" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M0 20.6906L15.9646 0L12.0708 14.116H22L5.25664 35L9.34513 20.6906H0Z" fill="#FFBC7E" />
								<path
									d="M0 20.6906L15.9646 0L12.0708 14.116H22L5.25664 35L9.34513 20.6906H0Z"
									fill="url(#paint0_linear)"
								/>
								<path d="M0 20.6906L15.9646 0L12.0708 14.116H22L5.25664 35L9.34513 20.6906H0Z" stroke="black" />
								<path
									d="M0 20.6906L15.9646 0L12.0708 14.116H22L5.25664 35L9.34513 20.6906H0Z"
									stroke="url(#paint1_linear)"
								/>
								<defs>
									<linearGradient id="paint0_linear" x1="22" y1="-20" x2="11" y2="35" gradientUnits="userSpaceOnUse">
										<stop stop-color="#FF8165" />
										<stop offset="1" stop-color="#FFC086" />
									</linearGradient>
									<linearGradient id="paint1_linear" x1="11" y1="0" x2="11" y2="35" gradientUnits="userSpaceOnUse">
										<stop stop-color="#EDDBFF" />
										<stop offset="1" stop-color="#D9B2FF" />
									</linearGradient>
								</defs>
							</svg>
						</div>
						<div class="note--text">
							Keep an accurate log of your daily activities in the app: your meals, liquid intake, activity, and weight
							changes
						</div>
					</div>

					<div class="advantages">
						<div class="advantage">
							<div class="advantage-icon">
								<svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M21.5114 3.05819L18.4532 0L8.67596 9.77725L3.16244 4.26373L0.104248 7.32192L8.67601 15.8937L11.7342 12.8355L11.7342 12.8354L21.5114 3.05819Z"
										fill="#7A89ED"
									/>
								</svg>
							</div>
							<div class="advantage-content">
								<div class="advantage-content--title">PERFORMANCE CHARTS</div>
								<div class="advantage-content--value">
									A comprehensive analysis and breakdown of your eating habbits, water intake, and activity
								</div>
							</div>
						</div>

						<div class="advantage">
							<div class="advantage-icon">
								<svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M21.5114 3.05819L18.4532 0L8.67596 9.77725L3.16244 4.26373L0.104248 7.32192L8.67601 15.8937L11.7342 12.8355L11.7342 12.8354L21.5114 3.05819Z"
										fill="#7A89ED"
									/>
								</svg>
							</div>
							<div class="advantage-content">
								<div class="advantage-content--title">Personalized Insights</div>
								<div class="advantage-content--value">
									Tons of tailored educational content based on you nutrition and activity habits
								</div>
							</div>
						</div>

						<div class="advantage">
							<div class="advantage-icon">
								<svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M21.5114 3.05819L18.4532 0L8.67596 9.77725L3.16244 4.26373L0.104248 7.32192L8.67601 15.8937L11.7342 12.8355L11.7342 12.8354L21.5114 3.05819Z"
										fill="#7A89ED"
									/>
								</svg>
							</div>
							<div class="advantage-content">
								<div class="advantage-content--title">WELLNESS COMPANION</div>
								<div class="advantage-content--value">
									It will walk by your side on this journey and provide assistance, whenever you need it
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>

		<template v-slot:footer>
			<div class="container">
				<a @click.prevent="handleClick" href="" class="btn btn-primary btn-block">LET’S GET STARTED</a>
			</div>
		</template>
	</Page>
</template>

<script>
import Page from '@/components/Page'
import { inject } from '@vue/runtime-core'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

export default {
	components: {
		Page
	},

	setup() {
		const store = useStore()
		const router = useRouter()
		const amplitude = inject('amplitude')

		const close = (Status = 'Close', NextRoute = null) => {
			amplitude.logEvent('Success - Close', {
				Layout: 'Workbooks',
				From: store.getters['getSource'],
				Step: 'Success',
				Status
			})
			router.push({
				name: NextRoute || 'workbooks',
				query: {
					Status
				}
			})
		}

		const handleClick = () => close()

		return {
			handleClick
		}
	}
}
</script>

<style lang="scss" scoped>
.top {
	background: radial-gradient(108.21% 105.83% at 81.07% -7.78%, #bc74ff 0%, #5d6fe4 100%), #bc74ff;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	padding: 3.5rem 0 4.8rem 0;
	text-align: center;
}

.title {
	font-weight: bold;
	color: #fff;
	margin-top: 1rem;
	font-size: 2.2rem;
}

.subtitle {
	color: #fff;
	font-size: 1.8rem;
	font-weight: 300;
	max-width: 80%;
	line-height: 1.4;
	margin-top: 0.2rem;
}

.note {
	display: flex;
	align-items: center;
	background-color: #fff2d9;
	border-radius: 0.8rem;
	padding: 1.2rem 2rem;
	line-height: 1.3;
	transform: translateY(-50%);

	&--text {
		padding-left: 1.2rem;
	}
}

.advantages {
	margin-top: -1rem;
}

.advantage {
	display: flex;
	align-items: center;
	margin-bottom: 1.2rem;

	&:last-child {
		margin-bottom: 0;
	}

	&-icon {
		width: 4.4rem;
		display: flex;
		justify-content: center;
	}

	&-content {
		width: calc(100% - 4.4rem);

		&--title {
			font-weight: bold;
			text-transform: uppercase;
			font-size: 1.14rem;
		}

		&--value {
			opacity: 0.8;
			margin-top: 0.2rem;
		}
	}
}
</style>
